import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AlertService } from 'src/app/services/alert.service';
import { NeoParametrizacionAliadoIntermediarioDTO } from '../../Model/NeoParametrizacionAliadoIntermediarioDTO';
import { NeoIntermediarioFinancieroService } from '../../Service/neoIntermediarioFinanciero.service';
import { UserService } from '../../../services/user.service';
import { SweetAlertService } from 'src/app/services/sweet-alert.service';

declare var $: any;
@Component({
    selector: 'app-administracion-parametrizacion-aliado',
    templateUrl: './administracion-parametrizacion-aliado.component.html',
    styleUrls: ['./administracion-parametrizacion-aliado.component.scss'],
    standalone: false
})
export class AdministracionParametrizacionAliadoComponent implements OnInit {
  //Formulario filtro
  filtrosForm: UntypedFormGroup;
  parametrizarNeoAliadoIntermediarioDTO: NeoParametrizacionAliadoIntermediarioDTO;
  user: any;
  listaTipos: any[] = [];
  tiposPersonaModificar: any[];
  tiposPersonaMostrar: any[] = [];
  mostrar: any[] = [];
  listaEnvio: number[] = [];


  constructor(
    private formBuilder: UntypedFormBuilder,
    private alertService: AlertService,
    private router: Router,
    private neoIntermediarioFinancieroService: NeoIntermediarioFinancieroService,
    private _userIntermediarioService: UserService,
    private _sweetAlert:SweetAlertService
  ) {
    this.user = this._userIntermediarioService.getUser();
    this.parametrizarNeoAliadoIntermediarioDTO = new NeoParametrizacionAliadoIntermediarioDTO(
      +this.user.idCliente,
      null
    );
  }

  ngOnInit(): void {
    this.crearFormularioFiltros();
    this.cargarListaTipos();
    this.cargarTiposPersona();
  }

  cargarListaTipos() {
    this.neoIntermediarioFinancieroService.getTipos().subscribe(
      (resp: any) => {
        this.listaTipos = resp;
        this.cargarSelectTiposPersona();
      }, (error) => {
        this._sweetAlert.errorModal("Error!",true,'No fue posible conectar con el servidor');
      }
    );
  }

  crearFormularioFiltros() {
    this.filtrosForm = this.formBuilder.group({
      tipoPersona: ['', Validators.required]
    });
  }

  cargarTiposPersona() {
    this.neoIntermediarioFinancieroService.getTiposPersona(this.user.idCliente).subscribe(
      (response: any) => {
        for (let i = 0; i < response.data.length; i++) {
          this.mostrar[i] = Number(response.data[i].idTipoPersonaJuridica);
        }
        this.filtrosForm.get('tipoPersona').setValue(this.mostrar);
      }, (error) => {
        this._sweetAlert.errorModal("Error!",true,'No fue posible conectar con el servidor');
      },
      () => {
        setTimeout(() => {
          $('.selectpicker').selectpicker('refresh');
        });
      }
    );
  }

  cargarSelectTiposPersona() {
    this.tiposPersonaMostrar.length = 0;
    for (let i = 0; i < this.listaTipos.length; i++) {
      this.tiposPersonaMostrar[i] = Number(this.listaTipos[i].idTipoPersonaJuridica);
    }
      this.filtrosForm.get('tipoPersona').setValue(this.tiposPersonaMostrar);
      $('#select_tipoPersona').selectpicker('refresh');
  }

  onSubmit() {
    this.tiposPersonaModificar = this.filtrosForm.get('tipoPersona').value;
    this.parametrizarNeoAliadoIntermediarioDTO.idsTipoPersonaJuridica = this.filtrosForm.get('tipoPersona').value;
    this.neoIntermediarioFinancieroService.guardarCambios(this.parametrizarNeoAliadoIntermediarioDTO).subscribe(
      (resp: any) => {
        if (resp.exitoso) {
          this._sweetAlert.successModal('Se realizo los cambios Exitosamente!');
        } else {
          this._sweetAlert.errorModal("Error!",true,'Se presento falla en el servicio!');
        }
      }, (error) => {
        this._sweetAlert.errorModal("Error!",true,'No fue posible conectar con el servidor');
      }
    );
  }

  validateForm(field: string) {
    return (
      (this.filtrosForm.get(field)?.dirty ||
        this.filtrosForm.get(field)?.touched) &&
      this.filtrosForm.get(field)?.invalid
    );
  }

  goHome() {
    this.router.navigate(['/intermediario/home']);
  }
}
